import { IconProps, StackProps } from '@chakra-ui/react';

import { CheckIcon, CopyIcon, HStack } from 'components/uikit';

interface CopyWrapperProps extends StackProps {
  copy?: boolean;
  small?: boolean;
  onCopy: () => void;
  hasCopied: boolean;
}

export const DynamicCopyIcon = ({
  hasCopied,
  color,
  ...props
}: Pick<CopyWrapperProps, 'hasCopied'> & IconProps) => {
  return hasCopied ? (
    <CheckIcon {...props} color={color ?? 'success.button'} />
  ) : (
    <CopyIcon {...props} color={color} />
  );
};

export const CopyWrapper = ({
  hasCopied,
  onCopy,
  children,
  copy = false,
  small = false,
  color,
  ...props
}: CopyWrapperProps) => {
  const copyIcon = copy ? (
    <DynamicCopyIcon
      hasCopied={hasCopied}
      boxSize={small ? '12px' : '16px'}
      color={color ?? (small ? 'grey.secondaryText' : 'grey.primaryText')}
      bottom='2px'
    />
  ) : null;

  return (
    <HStack
      flexWrap='wrap'
      align='center'
      cursor={copy ? 'pointer' : undefined}
      onClick={(e) => {
        e.stopPropagation();
        if (copy) onCopy();
      }}
      {...props}
    >
      {children}
      {copyIcon}
    </HStack>
  );
};
